import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import Swal from 'sweetalert2';
import { SmsTemplateCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { SCUISmsTriggerDrawerContent } from './SCUISmsTriggerDrawerContent';
import { SMS } from '../smsTemplate.classes';

interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
    onUpdate?: any;
}

export const SCUISmsTemplateDrawerContent: FC<IProps> = ({ selectedRow, onCloseMenu, onUpdate }) => {
    const handleChangeBody = (event: any) => {
        setBody(event.target.value);
    };
    const handleChangeSubject = (event: any) => {
        setSubject(event.target.value);
    };
    const handleChangeSmsTemplateKeyword = (event: any) => {
        setSmsTemplateKeyword(event.target.value);
    };
    const handleChangeCultureCode = (event: any) => {
        setCultureCode(event.target.value);
    };

    const updateSmsTemplate = () => {
        Swal.fire({
            text: t('smsTemplate.drawer.updateConfirm'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.body = body;
                params.cultureCode = cultureCode;
                params.subject = subject;
                params.smsTemplateKeyword = smsTemplateKeyword;
                params.isActive = isActive;
                SmsTemplateCommand.UpsertSms(params)
                    .then(() => {
                        Swal.fire(t('general.updated'), ' ', 'success');
                        onUpdate();
                    })
                    .finally(() => {});
            }
        });
    };
    const CreateSmsTemplate = async () => {
        let params: any = {};
        params.body = body;
        params.cultureCode = cultureCode;
        params.subject = subject;
        params.smsTemplateKeyword = smsTemplateKeyword;
        params.isActive = isActive;
        if (
            body &&
            body?.trim().length > 0 &&
            smsTemplateKeyword &&
            smsTemplateKeyword?.trim().length > 0 &&
            isActive &&
            isActive?.trim().length > 0
        ) {
            SmsTemplateCommand.UpsertSms(params)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    onUpdate();
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const { t } = useTranslation();
    const [body, setBody] = React.useState(selectedRow.body);
    const [isActive, setIsActive] = React.useState(selectedRow.isActive);
    const [subject, setSubject] = React.useState(selectedRow.subject);
    const [cultureCode, setCultureCode] = React.useState(selectedRow.cultureCode);
    const [smsTemplateKeyword, setSmsTemplateKeyword] = React.useState(selectedRow.smsTemplateKeyword);
    const _handleChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsActive(event.target.checked ? 'true' : 'false');
    };
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const onModalEditClose = () => setOpenEditModal(false);
    const onModalEditOpen = () => setOpenEditModal(true);

    return (
        <Grid
            className={`designCollectiveselectedRowGrid ${SMS.templateDrawer}`}
            data-keyword={selectedRow?.smsTemplateKeyword}
        >
            <Grid container sx={{ paddingTop: '2rem' }} className={SMS.templateDrawerHeader}>
                <SCUISmsTriggerDrawerContent
                    open={openEditModal}
                    onCloseMenu={onModalEditClose}
                    selectedRow={selectedRow}
                />
                <Grid
                    className={SMS.templateDrawerTitleBox}
                    sx={{ paddingLeft: '3rem' }}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11,
                    }}
                >
                    <h1 className={`headtxt ${SMS.templateDrawerTitle}`}>
                        {selectedRow?.smsTemplateKeyword ? selectedRow?.smsTemplateKeyword : t('smsTemplate.add')}
                    </h1>
                </Grid>
                <Grid
                    className={SMS.templateDrawerCloseBox}
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon className={`svg_icons ${SMS.btnTemplateClose}`} onClick={onCloseMenu} />
                </Grid>
            </Grid>
            <Grid container sx={{ padding: '3rem' }} className={SMS.templateForm}>
                <br />

                <Grid
                    className={SMS.templateFieldKeyword}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={SMS.inputKeyword}
                        label="Sms Template Keyword"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.smsTemplateKeyword}
                        onChange={handleChangeSmsTemplateKeyword}
                    />
                </Grid>
                <Grid
                    className={SMS.templateFieldBody}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={SMS.inputBody}
                        label="Body"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.body}
                        onChange={handleChangeBody}
                        multiline
                    />
                </Grid>
                <Grid
                    className={SMS.templateFieldSubject}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={SMS.inputSubject}
                        label="Subject"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.subject}
                        onChange={handleChangeSubject}
                    />
                </Grid>
                <Grid
                    className={SMS.templateFieldCultureCode}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={SMS.inputCultureCode}
                        label="Culture Code"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.cultureCode}
                        onChange={handleChangeCultureCode}
                    />
                </Grid>

                <Grid
                    className={SMS.templateFieldIsActive}
                    sx={{ marginTop: '1rem' }}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControlLabel
                        className={SMS.inputIsActiveLabel}
                        label="IsActive"
                        control={
                            <Switch
                                className={SMS.inputIsActive}
                                checked={isActive === 'true'}
                                onChange={_handleChangeStatus}
                                data-keyword={selectedRow?.smsTemplateKeyword}
                                data-is-active={isActive === 'true' ? 'true' : 'false'}
                            />
                        }
                    />
                </Grid>
                <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: '2rem', marginBottom: '2rem' }}
                    className={SMS.templateActions}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        className={SMS.templateActionsLeft}
                        size={{
                            xs: 6,
                            sm: 6,
                        }}
                    >
                        {selectedRow.arrayKeyword?.length > 0 && (
                            <SCUIButton
                                className={SMS.btnSendSms}
                                text={'Sms Gönder'}
                                type="primary"
                                sizeType="default"
                                size={'l'}
                                onClick={() => {
                                    onModalEditOpen();
                                }}
                            ></SCUIButton>
                        )}
                    </Grid>
                    <Grid className={SMS.templateActionsRight}>
                        {selectedRow.smsTemplateKeyword ? (
                            <SCUIButton
                                className={SMS.btnTemplateUpdate}
                                text={t('general.update')}
                                type="primary"
                                sizeType="default"
                                size={'m'}
                                fullwidth
                                onClick={() => updateSmsTemplate()}
                            ></SCUIButton>
                        ) : (
                            <SCUIButton
                                className={SMS.btnTemplateSave}
                                text={t('smsTemplate.save')}
                                type="primary"
                                sizeType="default"
                                size={'m'}
                                onClick={() => CreateSmsTemplate()}
                            ></SCUIButton>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
